import { FETCH_RESERVATIONS_SUCCESS } from '../constants/ActionTypes'

export default function reservations(state = {}, action) {
    switch (action.type) {
        case FETCH_RESERVATIONS_SUCCESS:
            return action.reservations
        default:
            return state
    }
}
